
export default class InView {
	constructor() {
		this.node = document.querySelectorAll('.does--animate');

		if (!this.node) {
			return;
		}

		const config = {
			threshold: [ 0.75 ]
		};

		function handleIntersection(entries) {
			entries.map((entry) => {
				if (entry.isIntersecting) {
					entry.target.src = entry.target.dataset.src;
					entry.target.classList.add('visible');
					observer.unobserve(entry.target);
				}
			});
		}

		const observer = new IntersectionObserver(handleIntersection, config);

		this.node.forEach(item => observer.observe(item));
	}

};
